import React, { useState, useEffect } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import GrnPOModal from "../components/grnPoModal";
import Time from "../components/time";
import { useParams, useNavigate, Link } from "react-router-dom";
import Swal from "sweetalert2";

const GrnConfirmViewSingle = () => {
  useAuthRedirect();
  const { grnNo, poNo } = useParams();
  const [showModal, setShowModal] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]); 
  const branch = localStorage.getItem("branch");
  const user = localStorage.getItem("username");
  const [detail, setGrnDetail] = useState({});  
  const [supplierNo, setSupplierNo] = useState(null);  
  const [poDate, setPoDate] = useState(null);  
const [freight, setFreight] = useState(""); 
const [subDetails, setSubDetails] = useState({})
const [formData, setFormData] = useState({
  // rejectReason : "",
})
const [rejectReasons, setRejectReasons] = useState({});
const navigate = useNavigate();
const [quantities, setQuantities] = useState({}); 


useEffect(() => {
    const fetchGrnDetails = async () => {
      try {
        const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/grnInspection_detailsHeader?branch=${branch}&grnNo=${grnNo}`);
        if (response.data && response.data.headerDetails?.length > 0) {
            const items = response.data.headerDetails;

            const storeReqHeader = {
                grnheader_date: items[0].grnheader_date || "N/A",
                purchaseOrderHeader_podate: items[0].purchaseOrderHeader_podate || "N/A",
                grnheader_DcNumber: items[0].grnheader_DcNumber || "N/A",
                grnheader_DcDate: items[0].grnheader_DcDate || "N/A",
                grnheader_invoiceDate: items[0].grnheader_invoiceDate || "N/A",
                grnheader_invoiceNumber: items[0].grnheader_invoiceNumber || "N/A",
                grnheader_suppliercode: items[0].grnheader_suppliercode || "N/A",
            };

            setGrnDetail(storeReqHeader);
        }
      } catch (error) {
        console.error("Error fetching locations:", error);
      }
    };

    fetchGrnDetails();
  }, [branch, grnNo]); 


  const [loading, setLoading] = useState(true); // loading state

useEffect(() => {
  const fetchData = async () => {
    try {
      setLoading(true); // start loading
      const response = await axios.get(
        `https://rfs2.infraconsoft.net.in/api/grnConfirm_data?branch=${branch}&grnNo=${grnNo}`
      );
      setSelectedItems(response.data.grnInspectionData);
    } catch (error) {
      console.error("Error fetching grnInspectionData:", error);
    } finally {
      setLoading(false); // stop loading
    }
  };
  fetchData();
}, [branch, grnNo]);


useEffect(() => {
    const fetchSupplierDetails = async () => {
      try {
        const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/purchaseOrder_supDetails?supplierCode=${detail.grnheader_suppliercode}`);
            const items = response.data.supDetails;
            const storeReqHeader1 = {
                supplierMaster_code: items[0].supplierMaster_code || "N/A",
                supplierMaster_name: items[0].supplierMaster_name || "N/A",
                address1: items[0].supplierMaster_addressline1 || "N/A",
                address2: items[0].supplierMaster_addressline2 || "N/A",
                city: items[0].supplierMaster_city || "N/A",
                pincode: items[0].supplierMaster_pincode || "N/A",
            };
            setSubDetails(storeReqHeader1);
      } catch (error) {
        console.error("Error fetching locations:", error);
      }
    };

    fetchSupplierDetails();
  }, [detail.grnheader_suppliercode]); 
  

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (selectedItems.length === 0) {
        Swal.fire("Error", "Please add at least one item", "error");
        return;
    }

    const payload = {
        branch: branch,
        user: user,
        grnNo: grnNo,
        items: selectedItems.map((item) => {
            return {
                itemCode: item.grnDetail_itemcode,
                accQty: item.grnDetail_acceptedQuantity,
                rejQty: item.grnDetail_rejectedQuantity,
            };
        }),
    };

    console.log(payload);

    try {
         Swal.fire({
                    title: "Submitting...",
                    text: "Please wait while we process your request.",
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading();
                    },
                });

        const response = await axios.put("https://rfs2.infraconsoft.net.in/api/grnConfirm_insert", payload);
        Swal.fire("Success", "GRN added successfully", "success");
        setSelectedItems([]);
        navigate('/inventory/grnConfirm');
    } catch (error) {
        console.error("Error submitting form:", error);
        Swal.fire("Error", "Submission failed. Please try again.", "error");
    }
};


  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
            <div className="back-div">
            <h2 className="add-txt">Goods Receipt Note - Confirm</h2>
            <Link to='/inventory/grnConfirm'><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
            </div>
          <Time />
        </section>

        <div className="form-container">
          <form className="vehicle-form" onSubmit={handleSubmit}>
          <div className="form-row">
              <div className="form-group">
                <label>GRN Number :</label>
                <input type="text" name="PoNumber" value={grnNo} readOnly />
              </div>
              <div className="form-group">
                <label>GRN Date :</label>
                <input type="text" name="invoiceDate" value={detail.grnheader_date ? new Date(detail.grnheader_date).toLocaleDateString("en-GB") : ""}  onChange={handleChange} readOnly/>
              </div>
            </div>


            <div className="form-row">
              <div className="form-group">
                <label>Supplier Code :</label>
                <input type="text" name="scode" value={subDetails.supplierMaster_code} readOnly/>
              </div>
              <div className="form-group">
                <label>Supplier Name :</label>
                <input type="text" name="sname" value={subDetails.supplierMaster_name} readOnly/>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>DC No :</label>
                <input type="text" name="dcNo" value={detail.grnheader_DcNumber}  onChange={handleChange} readOnly/>
              </div>
              <div className="form-group">
                <label>DC Date :</label>
                <input type="text" name="invoiceDate" value={detail.grnheader_DcDate ? new Date(detail.grnheader_DcDate).toLocaleDateString("en-GB") : ""}  onChange={handleChange} readOnly/>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Invoice No :</label>
                <input type="text" name="invoiceNo" value={detail.grnheader_invoiceNumber}  onChange={handleChange} readOnly/>
              </div>
              <div className="form-group">
                <label>Invoice Date :</label>
                <input type="text" name="invoiceDate" value={detail.grnheader_invoiceDate ? new Date(detail.grnheader_invoiceDate).toLocaleDateString("en-GB") : ""}  onChange={handleChange} readOnly/>

              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Address 1 :</label>
                <input type="text" name="scode" value={subDetails.address1} readOnly/>
              </div>
              <div className="form-group">
                <label>Address 2 :</label>
                <input type="text" name="sname" value={subDetails.address2} readOnly/>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>City :</label>
                <input type="text" name="scode" value={subDetails.city} readOnly/>
              </div>
              <div className="form-group">
                <label>Pin code :</label>
                <input type="text" name="sname" value={subDetails.pincode} readOnly/>
              </div>
            </div>

            <div className="content-table">
              <table>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Item Code</th>
                    <th>Item Name</th>
                    <th>Uom</th>
                    <th>GRN qty</th>
                    <th>Accepted Qty</th>
                    <th>Rejected Qty</th>
                    <th>Rejection Reason</th>
                    <th>Accp Value</th>
                    <th>Prepared By</th>
                  </tr>
                </thead>
               <tbody>
  {loading ? (
    <tr>
      <td colSpan="10" style={{ textAlign: "center", fontWeight: "bold" }}>
        Please wait, loading...
      </td>
    </tr>
  ) : selectedItems.length > 0 ? (
    selectedItems.map((item, index) => (
      <tr key={index}>
        <td>{index + 1}</td>
        <td>{item.grnDetail_itemcode}</td>
        <td>{item.itemmaster_name}</td>
        <td>{item.itemMaster_purchaseUom}</td>
        <td>{item.grnDetail_poPendingQuantity}</td>
        <td style={{ color: "green", fontWeight: "bold" }}>
          {item.grnDetail_acceptedQuantity}
        </td>
        <td style={{ color: "red", fontWeight: "bold" }}>
          {item.grnDetail_rejectedQuantity}
        </td>
        <td>{item.grnDetail_RejectionReason}</td>
        <td>{item.grnDetail_acceptedValue.toFixed(2)}</td>
        <td>{user}</td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="10" style={{ textAlign: "center" }}>
        No items added
      </td>
    </tr>
  )}
</tbody>
              </table>

            </div>
            <div className="btn-cls">
              <button type="submit" className="submit-btn">
                Checkout
              </button>
            </div>
          </form>
        </div>
      </div>

      <GrnPOModal showModal={showModal} closeModal={() => setShowModal(false)} branch={branch}  />
    </div>
  );
};

export default GrnConfirmViewSingle;
